import type { FacetOption } from '../types/Facet';

interface FacetOptionUidValuePairs {
  uid: string;
  value: FacetOption['value'];
}

export const setOptionsValues = (
  facetOptions: FacetOption[],
  optionUidValuePairs: FacetOptionUidValuePairs[],
) => {
  return facetOptions.map((option) => {
    const newOptionState = optionUidValuePairs.find(({ uid }) => option.uid === uid);

    if (newOptionState) {
      return {
        ...option,
        active: newOptionState.value !== null,
        value: newOptionState.value,
      };
    }

    return option;
  });
};

export const setOptionActiveByValue = (
  facetOptions: FacetOption[],
  value: FacetOption['value'],
  active: boolean,
): FacetOption[] => {
  return facetOptions.map((option) => {
    if (option.value === value) {
      return {
        ...option,
        active,
      };
    }

    return option;
  });
};

export const setOptionToActiveRemoveOthers = (
  facetOptions: FacetOption[],
  value: FacetOption['value'],
): FacetOption[] => {
  const activatedOption = facetOptions.find((option) => option.value === value)!;

  return [{ ...activatedOption, active: true }];
};

export const setOptionToActiveSetOthersToInactive = (
  facetOptions: FacetOption[],
  value: FacetOption['value'],
) => {
  return facetOptions.map((option) => {
    return {
      ...option,
      active: option.value === value,
    };
  });
};
